module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iNDgiPjxwYXRoIGQ9Ik00MjAtODB2LTI4MGgtODB2LTI1M3EwLTI0Ljc1IDE3LjYyNS00Mi4zNzVUNDAwLTY3M2gxNjBxMjQuNzUgMCA0Mi4zNzUgMTcuNjI1VDYyMC02MTN2MjUzaC04MHYyODBINDIwWm02MC4wOC02NTRxLTMwLjA4IDAtNTEuNTgtMjEuNDItMjEuNS0yMS40MjEtMjEuNS01MS41IDAtMzAuMDggMjEuNDItNTEuNTggMjEuNDIxLTIxLjUgNTEuNS0yMS41IDMwLjA4IDAgNTEuNTggMjEuNDIgMjEuNSAyMS40MjEgMjEuNSA1MS41IDAgMzAuMDgtMjEuNDIgNTEuNTgtMjEuNDIxIDIxLjUtNTEuNSAyMS41WiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/man.svg
// module id = SlS8
// module chunks = 0